import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IPieChartData } from '../../models/IPieChartData';

@Injectable({
  providedIn: 'root'
})
export class PieDataService {

  constructor() { }

  private data: IPieChartData[] = [];

  setData(newData: IPieChartData[]){
    this.data = newData;
    this.dataSubject.next(this.data);
  }

  private dataSubject = new BehaviorSubject<IPieChartData[]>(this.data);

  $data = this.dataSubject.asObservable();

  updateData(newData: IPieChartData[]){
    this.data = newData;
    this.dataSubject.next(this.data);
  }

}
